module.exports = __webpack_public_path__ + "img/sammjo_ogle.2c30f9c9.png";